import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { Icon } from '../Icon/Icon.js';
import './StartScreenModal.css';

export const StartScreenModal = ({
  isOpen = false,
  onClose,
  onStartFromScratch,
  onImportConfigs,
  onLoadPresetGraphicDesign,
  onLoadPresetUIDesign,
  className = '',
  ...props
}) => {
  const modalRef = useRef(null);
  const cardsRef = useRef(null);

  // Close modal when clicking outside cards
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isOpen &&
        modalRef.current &&
        cardsRef.current &&
        !cardsRef.current.contains(event.target) &&
        modalRef.current.contains(event.target)
      ) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }
  }, [isOpen, onClose]);

  // Handle escape key
  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === 'Escape' && isOpen) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      return () => {
        document.removeEventListener('keydown', handleEscape);
      };
    }
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const baseClass = 'start-screen-modal';
  const combinedClassName = [baseClass, className].filter(Boolean).join(' ');

  return createPortal(
    <div ref={modalRef} className={combinedClassName}>
      <div className="scrim" onClick={onClose} />
      <div ref={cardsRef} className="main__start-screen-cards">
        <button
          type="button"
          className="main__start-screen-card"
          onClick={() => {
            onStartFromScratch();
            // Don't close modal here - let handler manage it
          }}
          aria-label="Start from scratch"
        >
          <span className="main__start-screen-card-cover">
            <span className="main__start-screen-card-cover-icon">
              <Icon name="add" size="medium" />
            </span>
          </span>
          <span className="main__start-screen-card-content">Start from scratch</span>
        </button>
        <button
          type="button"
          className="main__start-screen-card"
          onClick={() => {
            onImportConfigs();
            // Don't close modal here - let handler manage it
          }}
          aria-label="Import config"
        >
          <span className="main__start-screen-card-cover">
            <span className="main__start-screen-card-cover-icon">
              <Icon name="upload" size="medium" />
            </span>
          </span>
          <span className="main__start-screen-card-content">Import config</span>
        </button>
        <button
          type="button"
          className="main__start-screen-card"
          onClick={() => {
            onLoadPresetGraphicDesign();
            // Don't close modal here - let handler manage it
          }}
          aria-label="Try Graphic Design preset"
        >
          <span className="main__start-screen-card-cover main__start-screen-card-cover--image main__start-screen-card-cover--graphic" aria-hidden />
          <span className="main__start-screen-card-content">Try Graphic Design preset</span>
        </button>
        <button
          type="button"
          className="main__start-screen-card"
          onClick={() => {
            onLoadPresetUIDesign();
            // Don't close modal here - let handler manage it
          }}
          aria-label="Try UI Design preset"
        >
          <span className="main__start-screen-card-cover main__start-screen-card-cover--image main__start-screen-card-cover--ui" aria-hidden />
          <span className="main__start-screen-card-content">Try UI Design preset</span>
        </button>
      </div>
    </div>,
    document.body
  );
};
